
import { defineComponent } from 'vue'
import Tiles from '../Tiles'

export default defineComponent({
	name: 'Board',
	props: {
		gameState: String,
		mode: String,
	},
	data: () => ({
		index: [0,1,2,3,4,5,6,7],
		tiles: new Tiles(),
	}),
	methods: {
		click: function(i: number) {
			if (this.gameState === 'memorize') {
				this.$emit('playingStart')
			}
			if (this.tiles.moveIfAble(i)) {
				this.$emit('countUp')
				if (this.tiles.checkFinish()) {
					this.$emit('finish')
				}
			} else {
				// 動かない場合のフィードバック（揺らすとか？）
			}
		},
		visibility: function(i: number) {
			if (this.mode === 'open') return 'visible'
			if (this.gameState === 'level-select') return 'visible'

			if (this.gameState === 'memorize' || this.gameState === 'finish' || this.gameState === 'giveup') {
				if (this.mode === 'hidden') return 'semivisible'
				if (this.mode === 'even' && i % 2 === 1) return 'semivisible'
				return 'visible'
			}

			if (this.gameState === 'playing') {
				if (this.mode === 'hidden') return 'invisible'
				if (this.mode === 'even' && i % 2 === 1) return 'invisible'
				return 'visible'
			}
		}
	},
	watch: {
		gameState: function(newState, oldState) {
			if (newState === 'memorize') {
				this.tiles.shuffle()
			} 
		}
	},
})
